









































































































import { Component, Vue } from 'vue-property-decorator';
import { PropertiesApi } from 'modules/properties/api/properties';
import { ContactProperty } from 'modules/installation-wizard/classes/contactProperty';
import { SearchContactApi} from 'modules/search-contact/api/search-contact';
import { RecordVm } from 'modules/search-contact/classes/contactVm';
import PhoneInput from 'modules/core/components/forms/PhoneInput.vue';
import { ProfileModel } from 'modules/profile/classes/profile';
import { ProfileApi } from 'modules/profile/api/profile';
import { IntegrationApi } from '@/modules/integrations/api/integrations';
import { IntegrationDefinitionVm } from '@/modules/integrations/classes/integrationDefinitionVm';
import moment from 'moment';
import { ElButton } from 'element-ui/types/button';
import { ElCard } from 'element-ui/types/card';
import { ElTable } from 'element-ui/types/table';
import { ElTableColumn } from 'element-ui/types/table-column';
import { ElTag } from 'element-ui/types/tag';
import { ElTooltip } from 'element-ui/types/tooltip';

@Component({
  components: {
    PhoneInput,
  },
})
export default class SearchCotacts extends Vue {
  public loading: boolean = false;
  public records: RecordVm[] = [];
  public phoneNumber: string = '';
  public phoneModel: any = {
    phone: '',
    code: undefined,
  };
  public integrations: IntegrationDefinitionVm[] = [];
  public hasAccountIntegrations: boolean = true;
  public language: string = 'en';

  public profileApi: ProfileApi;
  private propertiesApi: PropertiesApi;
  private searchContactApi: SearchContactApi;
  private integrationApi: IntegrationApi;

  constructor() {
    super();
    this.propertiesApi = new PropertiesApi();
    this.searchContactApi = new SearchContactApi();
    this.profileApi = new ProfileApi();
    this.integrationApi = new IntegrationApi();
  }

  public async created() {
    const profile = await this.profileApi.getProfile();
    this.phoneModel.code = profile.defaultPhoneNumberPrefix;
    this.language = profile.language;

    this.integrations = await this.integrationApi.getIntegrationsDefinitions();
    const userIntegration = await this.integrationApi.list();
    this.hasAccountIntegrations = userIntegration.length > 0;
  }

  public async search() {
    await this.loadRecord(this.phoneNumber);
  }

  public async loadRecord(phoneNumber: string) {
    try {
      this.loading = true;

      const properties = await this.propertiesApi.getProps();
      const record = await this.searchContactApi.search(phoneNumber);

      if (record && properties && properties.length > 0) {
        const records: RecordVm[] = [];

        properties.forEach((elem: ContactProperty) => {
          if (elem.isActive === false) {
            return;
          }
          const item = new RecordVm(elem);

          const propertyValue = record.properties.filter((p: any) => p.propertyId === elem.propertyId)[0];

          if (propertyValue && propertyValue.value) {
            item.value = propertyValue.value;
            item.type = propertyValue.type;
            item.created =  moment(propertyValue.created).format('YYYY-MM-DD hh:mm'),
            item.modified = moment(propertyValue.modified).format('YYYY-MM-DD hh:mm'),
            records.push(item);
          }
        });

        this.records = records ? records : [];
      }
    } finally {
      this.loading = false;
    }
  }

  public getOriginType(origin: string|null) {
    const originMapper: any = {
      custom: null,
      pipedrive: 'warning',
      shoper: 'success',
      shopify: 'danger',
    };

    if (origin) {
      return originMapper[origin];
    } else {
      return originMapper.custom;
    }
  }

   public updatePhoneNumber(val: any) {
    this.phoneNumber = val.code + val.phone;
    this.phoneModel = val;
  }
}
